import { Link } from "react-router";
import { conditionHref } from "../../lib/links";
import type { Observation } from "../../models";
import { displayCode, displayName } from "../../models/conditions";

export function ObservationsRail({
  tenant,
  observations,
  selectedObsId,
  onSelectObs,
}: {
  tenant: string;
  observations: Observation[];
  selectedObsId: string | null;
  onSelectObs: (id: string | null) => void;
}) {
  if (observations.length === 0) {
    return (
      <aside className="obs-rail sketch pad">
        <h3 className="section-h">Observations</h3>
        <p className="empty">No findings yet.</p>
      </aside>
    );
  }
  return (
    <aside className="obs-rail sketch pad">
      <h3 className="section-h">Observations</h3>
      <ul className="obs-list">
        {observations.map((o) => {
          const isSelected = selectedObsId === o.id;
          const code = displayCode(o);
          return (
            <li key={o.id} className={`obs-card sev-${o.severity} ${isSelected ? "selected" : ""}`}>
              <button type="button" className="obs-card-body" onClick={() => onSelectObs(o.id)}>
                <header>
                  <div>
                    <span className="obs-name">{displayName(o)}</span>
                    {o.condition_code ? (
                      <Link
                        to={conditionHref(tenant, o.condition_code)}
                        className="obs-code obs-code-link"
                        onClick={(e) => e.stopPropagation()}
                        title="Open in taxonomy"
                      >
                        {code}
                      </Link>
                    ) : (
                      <span className="obs-code">{code}</span>
                    )}
                  </div>
                  <span className={`badge sev-${o.severity}`}>{o.severity}</span>
                </header>
                <p className="obs-snippet">"{o.evidence.snippet.slice(0, 200)}"</p>
                {o.rationale ? <p className="obs-rationale">{o.rationale}</p> : null}
                <footer>
                  turns {o.turn_range[0]}–{o.turn_range[1]} · {o.source}
                </footer>
              </button>
            </li>
          );
        })}
      </ul>
    </aside>
  );
}
